module.exports = __webpack_public_path__ + "static/media/ms.74a2a0a9.svg";